import React from "react";
import { ProSidebar, SidebarContent, SidebarFooter, SidebarHeader } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import "./sidebarSkeleton.scss";

/**
 * Skeleton loader for SideBar component
 * Maintains the same structure and dimensions as the actual SideBar
 */
const SidebarSkeleton = () => {
  return (
    <ProSidebar collapsed={false} className='vertical-menu position-fixed sidebar-skeleton'>
      <SidebarHeader className='menu-expand justify-content-center'>
        <div className='mt-2 company-logo-margin'>
          <div className='skeleton-logo skeleton-shimmer'></div>
        </div>
        <div className='skeleton-collapse-btn skeleton-shimmer'></div>
      </SidebarHeader>
      <div className='h-100 overflow-auto d-flex flex-column sidebar-content overflow-y-auto sidebar-scrollbar'>
        <SidebarContent>
          <div className='skeleton-menu'>
            {/* Skeleton menu items */}
            {[1, 2, 3, 4, 5, 6, 7].map((item) => (
              <div key={item} className='skeleton-menu-item skeleton-shimmer'>
                <div className='skeleton-icon'></div>
              </div>
            ))}
          </div>
        </SidebarContent>
        <SidebarFooter>
          <div className='skeleton-footer skeleton-shimmer'></div>
        </SidebarFooter>
      </div>
    </ProSidebar>
  );
};

export default SidebarSkeleton;
